(() => {
  const callback = () => {
    if (!window.themeComponents.snippets.register('sign-up-marketing-ds')) return;

    const PUBLIC_API_KEY = 'Smb5Zd';

    let pixelEventSent = false;

    const subscribeToList = async ({ marketingListId, sourceName, formData }) => {
      const { email, firstName, lastName, country, countryCode, phone } = formData;
      if (!marketingListId || !email) return;

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  ...(firstName && { first_name: firstName }),
                  ...(lastName && { last_name: lastName }),
                  ...(country && { location: { country } }),
                  ...(phone && { phone_number: `${countryCode}${phone}` }),
                },
              },
            },
            ...(sourceName && { custom_source: sourceName }),
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: marketingListId,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify(payload),
      };

      try {
        const request = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`,
          requestOptions,
        );

        if (!request.ok) {
          const data = await request.json();
          const errorLabel = data?.errors?.[0]?.detail || errorSubtitle.dataset.initialLabel;
          if (errorSubtitle) errorSubtitle.innerHTML = errorLabel;
        }

        showState({ state: request.ok ? 'success' : 'error' });

        /* Meta Pixel. Fires only here, after Klaviyo confirms the subscribe, so a pageview,
           a button click or a failed submit never counts. The event name comes from the
           section setting, so it is picked per page and an untracked page leaves it blank.
           fbq is the Facebook & Instagram app pixel: its web pixel runs with
           runtimeContext OPEN, so it lives in the main window and the theme can reach it.
           It is absent when marketing consent is denied, hence the guard.
           pixelEventSent keeps a re-submit after "try again" from sending a second event. */
        if (request.ok && !pixelEventSent && metaPixelEvent && window.fbq) {
          pixelEventSent = true;
          // Its own catch: the outer one shows the error state, and a tracking failure must never
          // tell someone their subscribe failed when Klaviyo already accepted it.
          try {
            window.fbq('track', metaPixelEvent, { content_name: sourceName || document.title });
          } catch (pixelError) {
            console.error(pixelError);
          }
        }
      } catch (error) {
        showState({ state: 'error' });
        console.error(error);
      }
    };

    const showState = ({ state }) => {
      states.forEach((element) => element.classList.toggle('hidden', element.dataset.state !== state));
    };

    const selectors = {
      container: '.sign-up-marketing',
      state: '.sign-up-marketing__state',
      stateError: '[data-state="error"]',
      statusSubtitle: '.sign-up-marketing__status-subtitle',
      statusTryAgainButton: '.sign-up-marketing__status-try-again-button',
      form: '#sign-up-form',
      formSubmitButton: '.sign-up-marketing__form-submit-button',
    };

    const container = document.querySelector(selectors.container);
    if (!container) return;

    const states = container.querySelectorAll(selectors.state);
    const form = container.querySelector(selectors.form);
    const formSubmitButton = container.querySelector(selectors.formSubmitButton);
    const errorSubtitle = container.querySelector(`${selectors.stateError} ${selectors.statusSubtitle}`);
    const errorTryAgainButton = container.querySelector(`${selectors.stateError} ${selectors.statusTryAgainButton}`);

    const { marketingListId, sourceName, metaPixelEvent } =
      window.themeComponents.snippets['sign-up-marketing-ds'] ?? {};

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();

      formSubmitButton?.classList?.add('btn--loading');

      await subscribeToList({
        marketingListId,
        sourceName,
        formData: Object.fromEntries(new FormData(form).entries()),
      });

      formSubmitButton?.classList?.remove('btn--loading');
    });

    errorTryAgainButton?.addEventListener('click', () => showState({ state: 'form' }));
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
